(ns ui.components.radix-ui.avatar.view
  (:require
   [reagent.core :as r]
   ["@radix-ui/react-avatar" :as Avatar]
   [ui.util :as uu]))

(defn adapt
  ([cls-name]
   (r/adapt-react-class (aget Avatar cls-name)))
  ([parent-cls cls-name]
   (r/adapt-react-class (aget (aget Avatar parent-cls) cls-name))))


(def avatar-root (adapt "Root"))
(def avatar-image (adapt "Image"))
(def avatar-fallback (adapt "Fallback"))

(defn view
  [{:keys [image-url fallback size font-size dom-id]}]
  (let [tailwind-size-class (case size
                              :small "w-8 h-8 "
                              :medium "w-12 h-12 "
                              :large "w-20 h-20 "
                              "w-10 h-10 ")
        tailwind-font-size-class (case font-size
                                   :small "text-[11px] "
                                   :medium "text-md "
                                   :large "text-xl "
                                   "text-xs ")]
    [avatar-root
     {:id    dom-id
      :class (uu/cm tailwind-size-class
                    "p-0.5 flex items-center justify-center text-base-light-text border-2 border-solid border-base-light-border-paler rounded-full")}
     [avatar-image
      {:src   image-url
       :class "w-full h-full object-cover rounded-full"}]
     [avatar-fallback
      {:class (uu/cm tailwind-font-size-class
                     "m-0 w-full h-full flex items-center justify-center text-base-light-text font-semibold text-uppercase rounded-full bg-base-light")}
      fallback]]))
